/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidationMessage
 */
export interface ValidationMessage {
    /**
     * 
     * @type {string}
     * @memberof ValidationMessage
     */
    text?: string | null;
}

export function ValidationMessageFromJSON(json: any): ValidationMessage {
    return ValidationMessageFromJSONTyped(json, false);
}

export function ValidationMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function ValidationMessageToJSON(value?: ValidationMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
    };
}


